import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const GraduateIcon = React.memo(
  ({ width = 47, fill = variables['colors-mc-graduate-icon'], viewBox = '0 0 47 47' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect
        id='Rectangle_1421'
        data-name='Rectangle 1421'
        width='47'
        height='47'
        rx='23.5'
        fill={fill}
      />
      <g id='mortarboard' transform='translate(11.661 13.216)'>
        <path
          id='Path_12345'
          data-name='Path 12345'
          d='M11.969,2.068a.729.729,0,0,0-.615,0L.421,7.17A.729.729,0,0,0,.457,8.507L11.39,12.88a.729.729,0,0,0,.542,0l8.475-3.388v8.542a1.458,1.458,0,0,0-1.458,1.458v2.915h4.373V19.492a1.458,1.458,0,0,0-1.458-1.458V8.908l1-.4A.729.729,0,0,0,22.9,7.17l-10.933-5.1Zm-.308,9.348L2.562,7.78l9.1-4.246,9.1,4.246Z'
          transform='translate(0 -2)'
          fill='#fff'
        />
        <path
          id='Path_12346'
          data-name='Path 12346'
          d='M4.714,9.047a.729.729,0,0,0-.956.477L3.029,12a.729.729,0,0,0,.429.882l6.56,2.624a.729.729,0,0,0,.542,0l6.56-2.624A.729.729,0,0,0,17.548,12l-.729-2.478a.729.729,0,0,0-.956-.477l-5.574,2.09Zm-.1,2.73.321-1.09,5.1,1.911a.729.729,0,0,0,.513,0l5.1-1.911.321,1.09-5.673,2.267L4.615,11.775Z'
          transform='translate(1.372 1.203)'
          fill='#fff'
        />
      </g>
    </svg>
  )
);
GraduateIcon.displayName = 'GraduateIcon';

export default GraduateIcon;
